export * from "./useOutsideClick";
